<template>
<div>
  <h3>Persönliche Angaben</h3>
  <div class="row">
    <div class="col-24 col-lg-8">
      <contact-select name="salutation" label="Anrede" group="contact" values="Frau,Herr" placeholder="Anrede"></contact-select>
    </div>
    <div class="col-24 col-lg-16">
      <contact-input name="name" label="Vor- und Nachname" group="contact"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-24 col-lg-9">
      <contact-input name="street" label="Straße, Haus-Nr." group="contact"></contact-input>
    </div>

    <div class="col-24 col-lg-6">
      <contact-input name="zip" label="PLZ" group="contact"></contact-input>
    </div>

    <div class="col-24 col-lg-9">
      <contact-input name="city" label="Ort" group="contact"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-24 col-lg-8">
      <contact-input name="phone" label="Telefon" group="contact"></contact-input>
    </div>
    <div class="col-24 col-lg-16">
      <contact-input name="email" label="E-Mail" group="contact"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-24 col-lg-14">
      <p>Durch wen ist die Meldung erfolgt?</p>
    </div>

    <div class="col-24 col-lg-10">
      <contact-select name="contactFrom" label="Bitte auswählen" group="contact" values="Eigentümer,Mieter" placeholder="Bitte auswählen"></contact-select>
    </div>
  </div>

  <h3>Objekt</h3>
  <div class="row">
    <div class="col-24 col-lg-8">
      <contact-input name="object" label="Objekt" group="contact"></contact-input>
    </div>
    <div class="col-24 col-lg-16">
      <contact-input name="objectLocation" label="Lage im Objekt (z.B. 1OG, links)" group="contact"></contact-input>
    </div>
  </div>

  <h3>Schaden</h3>
  <div class="row">
    <div class="col-24">
      <contact-input textarea name="schadenursache" group="contact" label="Schadensursache (falls bekannt)"></contact-input>
    </div>

    <div class="col-24">
      <contact-input textarea name="schadenbeschreibung" group="contact" label="Schadenbeschreibung"></contact-input>
    </div>

    <div class="col-24">
      <contact-input textarea name="beschaedigtesachen" group="contact" label="Beschädigte Sachen"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-24 col-lg-14">
      <p>Wurde der Notdienst der Verwaltung informiert?</p>
    </div>

    <div class="col-24 col-lg-10">
      <contact-select name="notdienstInformiert" label="Bitte auswählen" group="contact" values="Nein,Ja" placeholder="Bitte auswählen"></contact-select>
    </div>
  </div>

  <div class="row">
    <div class="col-24 col-lg-14">
      <p>Wann wurde der Schaden festgestellt?</p>
    </div>

    <div class="col-24 col-lg-10">
      <contact-date-picker name="date" group="contact" label="Bitte auswählen"></contact-date-picker>
    </div>
  </div>

  <div class="row">
    <div class="col-24">
      <v-radio-group v-model="contactType" row label="Kontaktaufnahme per: " class="my-0 py-0" :hide-details="true">
        <v-radio hide-details label="E-Mail" value="E-Mail" off-icon="fal fa-circle" on-icon="far fa-dot-circle"></v-radio>
        <v-radio hide-details label="Telefon" value="Telefon" off-icon="fal fa-circle" on-icon="far fa-dot-circle"></v-radio>
      </v-radio-group>
    </div>
  </div>

</div>
</template>

<script>
import ContactInput from "./ContactInput.vue";
import ContactSelect from "./ContactSelect.vue";
import ContactDatePicker from "./ContactDatePicker.vue";

export default {
  name: "SchadensmeldungForm",

  components: {
    ContactInput,
    ContactSelect,
    ContactDatePicker
  },

  methods: {
    contactType(val) {
      this.$root.contactForm.contact.contactType = val;
    }
  }
}
</script>
